import axios from 'axios'

const urlApi = window.location.href.includes('digiworks')
  ? 'https://api.' + window.location.hostname
  : 'https://api3.offres-delices.com'

const baseUrl =
  import.meta.env.MODE === 'production'
    ? urlApi
    : import.meta.env.VITE_BASE_URL_DEV

// const baseUrl =
//   import.meta.env.MODE === 'production'
//     ? 'https://api.' + window.location.hostname
//     : import.meta.env.VITE_BASE_URL_DEV

const apiService = axios.create({
  baseURL: baseUrl + '/api/v1',
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  validateStatus: (status) => {
    return status < 300 || status === 422
  }
})

const apiServiceGouv = axios.create({
  baseURL: 'https://geo.api.gouv.fr',
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  validateStatus: (status) => {
    return status < 300 || status === 422
  }
})

export const $api = {
  setApiToken(api_token) {
    apiService.defaults.headers['Authorization'] = 'Bearer ' + api_token
  },

  // USER
  createUser(body) {
    return apiService.post('/leads', body)
  },

  // PARTICIPATION
  validateParticipation(idParticipation, body) {
    return apiService.post(`/participations/${idParticipation}`, body)
  },

  // CAMPAIGN
  getAcquisitionCampaign(idCourse) {
    return apiService.get(`/campaigns/acquisition/${idCourse}`)
  },
  getRecallCampaign(token) {
    return apiService.get(`/campaigns/recall/${token}`)
  },

  // ORDER
  syncCart(idParticipation, body) {
    return apiService.post(`/orders/${idParticipation}`, body)
  },
  getCart(idParticipation, body) {
    return apiService.get(`/orders/${idParticipation}`, body)
  },

  // ADDRESS
  createAddress(idParticipation, body) {
    return apiService.post(`/addresses/${idParticipation}`, body)
  },
  getTowns(cp) {
    return apiServiceGouv.get(`/communes?codePostal=${cp}`)
  },

  // BANDIT
  playBandit(idParticipation) {
    return apiService.post(`/bandit/${idParticipation}`)
  },

  // WHEEL
  wheelSpin(campaignId, landingId, email, utmData = {}, optinVariant = null) {
    return apiService.post(`/wheel/spin`, {
      campaign_id: campaignId,
      landing_id: landingId,
      email,
      // UTM data pour le tracking agence
      utm_source: utmData.utm_source || null,
      utm_medium: utmData.utm_medium || null,
      utm_term: utmData.utm_term || null,
      utm_content: utmData.utm_content || null,
      utm_campaign: utmData.utm_campaign || null,
      var_oc: utmData.var_oc || null,
      optin_variant: optinVariant || null,
      aff_sub2: utmData.aff_sub2 || null,
      click_id: utmData.click_id || null,
      cid: utmData.cid || null,
      cd1: utmData.cd1 || null,
      cd3: utmData.cd3 || null,
    })
  },
  wheelGetWinner(token) {
    return apiService.get(`/wheel/winner/${token}`)
  },
  wheelUpdateCart(token, cart) {
    return apiService.put(`/wheel/winner/${token}/cart`, { cart })
  },
  wheelConvert(token, body) {
    return apiService.post(`/wheel/winner/${token}/convert`, body)
  },


  // PAYPAL
  createPaypalTransaction(idParticipation, body) {
    return apiService.post(`/paypal/${idParticipation}`, body)
  },
  approvePaypalTransaction(idParticipation, body) {
    return apiService.post(`/paypal/${idParticipation}/approve`, body)
  },
  // updatePaypalTransaction(idParticipation, body) {
  //   return apiService.post(`/paypal/${idParticipation}`, body)
  // },

  // OTHERS
  getGenders() {
    return apiService.get(`/genders`)
  },
  getProductsTemplate(idTemplate) {
    return apiService.get(`/products/${idTemplate}`)
  },
  previewEmail(token) {
    return apiService.get(`/preview/${token}`)
  },
}
